import React, { useEffect, useState, useRef, useImperativeHandle, forwardRef } from 'react';
import { injectIntl } from 'react-intl';
import { detectBrowser, generateUUID, detectIfBracketHasImages, affect_color_filter, getRoundLabel, isColorBright, RGB_2_HEX, isDesktop, isIOS } from '../../lib/ep.js';
import { Stage, Layer, Group, Rect, Text, Arc, Circle, Line, Shape, Path } from 'react-konva';
import { size as _size } from 'lodash';

import ActionLink from '../builder/ActionLink';
import Spinner from '../builder/Spinner';

import RoundVotesLayer from '../front/layers/RoundVotesLayer';

const sortPhases = (phases) => {
	return phases.sort((x, y) => {
		if(x.order < y.order) return -1;
		if(x.order > y.order) return 1;
		return 0;
	});
};

let throttle_resize;
let outline_color = 'rgba(255, 255, 255, 0.5)';
let white_color = 'rgba(255, 255, 255, 1)';
let black_color = 'rgba(0, 0, 0, 1)';
let out_color = 'rgba(215, 35, 60, 1)';

let actual_browser = detectBrowser();

const Wrapper = (props) => {
	const [display_round_votes, setDisplayRoundVotes] = useState(false);

	let bracket_id = props.bracket_id;
	let this_bracket_styles = props.this_bracket_styles;
	let c_styles = props.c_styles;
	let total_width_global = props.total_width_global;
	let m = props.m;
	let display_rounds = props.display_rounds;
	let header_height = props.header_height;
	let visible_phases = props.visible_phases;
	let phases = props.phases;
	let all_loaded = props.all_loaded;
	let bracket = props.bracket;
	let is_header_bg_color_bright = props.is_header_bg_color_bright;
	let is_voting_bracket = props.is_voting_bracket;
	let header_font_size_basis = props.header_font_size_basis;
	let text_scale = props.text_scale;
	let is_builder = props.is_builder;
	let is_zoomable = props.is_zoomable;
	let is_zoomed = props.is_zoomed;
	let is_widget = props.is_widget;
	let is_single = props.is_single;
	let is_zoomed_out = props.is_zoomed_out;
	let link_to_single = props.link_to_single;
	let main_color = props.main_color;
	let display_votes = props.display_votes;
	let display_view_votes_link = props.display_view_votes_link;
	let promotion = props.promotion;
	let matches_results = props.matches_results;
	let teams = props.teams;

	return (
		<div>
			<div class="gui_pos_rel">
				<div id={`brackets_${bracket_id}`} class="this_bracket" style={this_bracket_styles}>
					<div class="bracket_c" style={c_styles}>
						<div class="br_c"/* style={{height:(m * whole_bracket_height) + 'px'}}*/>
							<div class="bracket_container gui_pos_rel" style={{width:(m * total_width_global) + 'px'}}>
								{props.children}

								{(display_rounds) && (
									<div class={'phases_header'} style={{height:(m * header_height) + 'px', opacity:((all_loaded) ? '1' : '0')}}>
										{visible_phases.map((phase, p) => {
											let this_phase = phases.find((obj) => { return phase.phase_id == obj.id });
											let label_phase = (this_phase.label) ? this_phase.label : '';

											let header_classes = ['header_bg'];
											header_classes.push((is_header_bg_color_bright) ? 'is_light' : 'is_dark');

											let is_previous_round = (bracket.current_round > phase.phase_id) ? true : false;
											let is_actual_round = (bracket.current_round == phase.phase_id) ? true : false;
											let is_future_round = (bracket.current_round < phase.phase_id) ? true : false;

											let display_link_by_type;
											if(is_voting_bracket) {
												display_link_by_type = (is_previous_round) ? true : false;
											} else {
												display_link_by_type = (!is_future_round) ? true : false;
											}

											return (
												<div key={`phase_label_${p}`}>
													<div class={header_classes.join(" ")} style={{height:(m * header_height) + 'px', fontSize:(m * (header_font_size_basis * text_scale)) + 'pt'}}>
														<span>{label_phase}</span>
														{(display_view_votes_link && display_link_by_type) && (
															<ActionLink onClick={(!is_builder) ? () => setDisplayRoundVotes(phase.phase_id) : null}>View votes</ActionLink>
														)}
													</div>
												</div>
											)
										})}
									</div>
								)}
							</div>

							{(is_zoomable && !is_zoomed && !is_single) && (
								<div class="is_fullscreen relative_to_container" style={{border:'1px solid', zIndex:'2'}} />
							)}
						</div>

						{(is_single) && (
							<div class="dragger_help" style={{height:'calc(100% - ' + (m * header_height) + 'px)', top:(m * header_height) + 'px'}} />
						)}

						{(is_zoomable && (!is_single || is_widget) && link_to_single != undefined && link_to_single != "" && is_zoomed_out) && (
							<a class="go_to_full_bracket" href={link_to_single} target="_blank" style={{height:'calc(100% - ' + (m * header_height) + 'px)'}} />
						)}
					</div>

					{(!all_loaded) && (
						<div class="is_fullscreen relative_to_container" style={{zIndex:10}}>
							<Spinner force_bg={false} color={main_color}>Loading bracket</Spinner>
						</div>
					)}
				</div>
			</div>

			{(display_votes && display_round_votes !== false) && (
				<RoundVotesLayer pm={promotion} is_builder={is_builder} round={display_round_votes} matches_results={matches_results} bracket={bracket} teams={teams} main_color={main_color} backButton={() => setDisplayRoundVotes(false)} />
			)}
		</div>
	)
};

const ScoreText = (props) => {
	return (
		<Group>
			<Text {...props} />
		</Group>
	)
};

const WinnerIcon = (props) => {
	let m = props.m;
	let n = props.n;
	let radius = Math.min(10, props.radius);

	let star_size = 300;
	let star_scale = 2 * m * radius / star_size;

	return (
		<Group fill={null} {...props}>
			<Group rotation={15 * props.direction}>
				<Circle radius={m * radius} fill={props.fill} />

				<Path
					fill={props.icon_fill}
					data="M249.27,118.18c-1.63-4.98-5.79-8.74-10.95-9.89l-49.53-11.06l-25.91-43.27c-2.7-4.51-7.59-7.27-12.88-7.27c-5.29,0-10.18,2.76-12.88,7.27l-25.91,43.27l-49.53,11.06c-5.16,1.15-9.32,4.91-10.95,9.89c-1.63,4.98-0.5,10.45,2.99,14.39l33.51,37.8l-4.7,50.11c-0.49,5.22,1.83,10.3,6.11,13.38c4.28,3.08,9.88,3.7,14.73,1.62L150,215.56l46.62,19.91c1.9,0.81,3.92,1.21,5.92,1.21c3.11,0,6.2-0.96,8.8-2.83c4.28-3.08,6.6-8.17,6.11-13.38l-4.7-50.11l33.51-37.8C249.76,128.63,250.9,123.16,249.27,118.18z"
					width={star_size}
					height={star_size}
					scaleX={star_scale}
					scaleY={star_scale}
					x={-m * radius}
					y={-m * radius}
				/>
			</Group>
		</Group>
	)
};

const LooserCross = (props) => {
	let m = props.m;
	let n = props.n;
	let box_width = props.box_width;
	let box_height = props.box_height;
	let box_border_width = props.box_border_width;
	let displace_icon = props.displace_icon;

	let cross_size = box_height * 0.8;

	return (
		<Group rotation={45} x={m * (box_width / 2 + ((displace_icon) ? cross_size / 2 : 0))} y={m * box_height / 2}>
			<Line points={[-m * 2 * box_border_width, 0, m * (cross_size + 2 * box_border_width), 0]} stroke={white_color} strokeWidth={n * (5 + 4 * box_border_width)} x={-m * cross_size / 2} />
			<Line points={[0, -m * 2 * box_border_width, 0, m * (cross_size + 2 * box_border_width)]} stroke={white_color} strokeWidth={n * (5 + 4 * box_border_width)} y={-m * cross_size / 2} />
			<Line points={[0, 0, m * cross_size, 0]} stroke={out_color} strokeWidth={n * 5} x={-m * cross_size / 2} />
			<Line points={[0, 0, 0, m * cross_size]} stroke={out_color} strokeWidth={n * 5} y={-m * cross_size / 2} />
		</Group>
	)
};

const TeamBox = (props) => {
	let m = props.m;
	let n = props.n;
	let box_width = props.box_width;
	let box_height = props.box_height;
	let display_team_images = props.display_team_images;
	let display_team_images_only = props.display_team_images_only;
	let team = props.team;
	let winner = props.winner;
	let stage_padding = props.stage_padding;
	let direction = props.direction;
	let text_y_pos = props.text_y_pos;
	let used_color_team = props.used_color_team;
	let box_stroke_color = props.box_stroke_color;
	let box_border_width = props.box_border_width;
	let image = props.image;
	let winner_position = props.winner_position;
	let box_position = props.box_position;
	let is_iconic = props.is_iconic;
	let main_color = props.main_color;
	let flip_images = props.flip_images;

	let generic_group_props = props.generic_group_props;
	let generic_text_props = props.generic_text_props;

	let score_y_pos_displacement = 0;
	if(direction == 0) {
		switch(parseInt(props.num_rounds)) {
			case 2:
				score_y_pos_displacement = 1.5 * stage_padding;
				if(display_team_images_only) score_y_pos_displacement *= 1.2;
				break;
			case 3:
				score_y_pos_displacement = 1.75 * stage_padding;
				if(display_team_images_only) score_y_pos_displacement *= 1.35;
				break;
			case 4:
				score_y_pos_displacement = 2 * stage_padding;
				if(display_team_images_only) score_y_pos_displacement *= 1.5;
				break;
		}
	}

	const winner_bg_radius = box_height / 2;
	let has_winner = (winner !== false) ? true : false;
	let is_match_winner = (has_winner && ((box_position == 'top' && winner == '0') || (box_position == 'bottom' && winner == '1'))) ? true : false;

	let is_bracket_winner = (team !== false && props.display_final_winner && direction == 0 && (winner_position == box_position)) ? true : false;
	if(is_bracket_winner && false) used_color_team = main_color;

	let text_x = box_width / 2;
	if(display_team_images && (direction > 0 || (direction == 0 && box_position == 'top'))) text_x += box_height;

	let image_x_scale = (!display_team_images_only && flip_images && (direction < 0 || (direction == 0 && box_position == 'bottom'))) ? -1 : 1;

	let image_opacity = (display_team_images_only && has_winner && !is_match_winner) ? 0.3 : 1;
	let box_bg = props.box_bg;
	if(team.status == 2) {
		image_opacity *= (props.bracket_layout == 'light') ? 0.4 : 0.9;
		box_bg = (props.bracket_layout == 'light') ? affect_color_filter(-0.2, box_bg) : affect_color_filter(0.4, box_bg);
	}

	let score_y_pos = (box_position == 'top') ? -1 * (props.text_height + score_y_pos_displacement) : score_y_pos_displacement;

	let img_x = (image_x_scale > 0 && !display_team_images_only && (direction < 0 || (direction == 0 && box_position == 'bottom'))) ? (m * (box_width - box_height)) : 0;

	let has_custom_bg_color = (team.color != undefined && false) ? true : false;
	let color_text = (has_custom_bg_color) ? (isColorBright(RGB_2_HEX(team.color)) ? black_color : white_color) : used_color_team;

	return (
		<Group y={m * props.group_y} width={m * box_width} height={m * box_height} {...generic_group_props}>
			<Rect fill={(has_custom_bg_color) ? team.color : box_bg} width={m * box_width} height={m * box_height} />

			{(team !== false) && (
				<Group>
					{(display_team_images) && (
						<Group opacity={image_opacity} x={m * box_width / 2} scaleX={image_x_scale} width={m * box_width} height={m * box_height} offsetX={m * box_width / 2}>
							{(image !== false) ? (
								<Rect x={img_x} width={m * ((!display_team_images_only) ? box_height : box_width)} height={m * box_height} fillPatternImage={image.img.fillPatternImage} fillPatternRepeat='no-repeat' fillPatternScaleX={m * image.scale} fillPatternScaleY={m * image.scale} fillPatternOffsetY={(!display_team_images_only) ? 0 : ((image.img.image_h * image.scale - box_height) / (2 * image.scale))} />
							) : (
								<Rect x={img_x} width={m * ((!display_team_images_only) ? box_height : box_width)} height={m * box_height} fill={'#808080'} opacity={image_opacity} />
							)}
						</Group>
					)}

					{(props.display_team_texts) && (
						<Text x={m * text_x} y={m * text_y_pos} fill={color_text} opacity={(!has_winner || is_match_winner || has_custom_bg_color) ? 1 : 0.6} text={(props.display_team_full_name) ? team.name : team.short_name} {...generic_text_props} {...props.default_generic_text_props} />
					)}

					{(props.display_scores && props.match_score != undefined) && (
						<ScoreText
							align={(direction > 0) ? 'left' : ((direction < 0) ? 'right' : 'center')}
							fill={main_color}
							m={m}
							n={n}
							offsetY={-m * box_height / 2}
							text={props.match_score}
							x={m * (box_width / 2 + direction * (box_width + stage_padding))}
							y={m * score_y_pos}
							{...props.generic_score_text_props}
						/>
					)}
				</Group>
			)}

			<Rect width={m * box_width} height={m * box_height} stroke={(!is_iconic) ? used_color_team : box_stroke_color} strokeWidth={n * box_border_width} />

			{(is_bracket_winner) && (
				<WinnerIcon offsetX={(box_position == 'top') ? -m * box_width : 0} offsetY={(box_position == 'bottom') ? -m * box_height : 0} fill={used_color_team} icon_fill={props.box_bg} m={m} n={n} radius={winner_bg_radius} height={m * 2 * winner_bg_radius} width={m * 2 * winner_bg_radius} direction={(box_position == 'top') ? 1 : -1} />
			)}

			{(props.display_crosses_on_losers && !is_match_winner && has_winner) && (
				<LooserCross m={m} n={n} box_width={box_width} box_height={box_height} box_border_width={box_border_width} displace_icon={props.displace_icon} />
			)}
		</Group>
	)
};

const TeamConnector = (props) => {
	let m = props.m;
	let n = props.n;
	let is_iconic = props.is_iconic;
	let area_height = props.area_height;
	let box_width = props.box_width;
	let box_height = props.box_height;
	let box_y_pos = props.box_y_pos;
	let stage_padding = props.stage_padding;
	let min_matches_separation = props.min_matches_separation;
	let final_point_y = props.final_point_y;
	let used_color_team_1 = props.used_color_team_1;
	let used_color_team_2 = props.used_color_team_2;
	let pending_color = props.pending_color;
	let winner_color = props.winner_color;
	let phase = props.phase;
	let box_border_width = props.box_border_width;
	let is_outline = (props.is_outline != undefined) ? props.is_outline : false;

	let extra_width = (is_outline) ? is_outline : 0;
	let force_color = (is_outline) ? outline_color : false;

	let joining_lines_width = box_border_width * ((!is_iconic) ? 2 : 1) + extra_width;
	let joining_lines_pointer_radius = box_border_width * ((!is_iconic) ? 4 : 2) + extra_width / 2;

	let connector_stroke_default_props = {
		x:(m * ((phase.direction > 0) ? box_width : 0)),
		scaleX:phase.direction,
		strokeWidth:n * joining_lines_width,
	};

	let arc_default_props = {
		angle:180,
		innerRadius:0,
		outerRadius:n * joining_lines_pointer_radius,
		rotation:-90 * phase.direction,
		x:(m * ((phase.direction > 0) ? box_width : 0)),
	};

	return (
		<Group {...props.generic_group_props}>
			{(!is_iconic) && (
				<Line points={[0, 0, 0, m * (2 * (box_y_pos) - box_height)]} stroke={props.connectors_color} strokeWidth={n * 1} x={m * box_width / 2} y={m * ((area_height + 2 * box_height) / 2 - box_y_pos)} dash={[m * 1, m * 2]} opacity={0.5} />
			)}

			{/* SHAPE FROM TOP TEAM IN MATCH */}
			{(phase.direction != 0) && (
				<Shape
					sceneFunc={(context, shape) => {
						context.beginPath();
						context.moveTo(0, 0);
						context.lineTo(m * stage_padding, 0);
						context.lineTo(m * stage_padding, m * (box_y_pos - final_point_y));
						if(used_color_team_1 == winner_color) context.lineTo(m * min_matches_separation, m * (box_y_pos - final_point_y));
						context.fillStrokeShape(shape);
					}}
					stroke={(force_color) ? force_color : used_color_team_1}
					y={m * ((area_height + box_height) / 2 - box_y_pos)}
					dash={(used_color_team_1 != winner_color && false) ? [m * 4, m * 3] : null}
					{...connector_stroke_default_props}
				/>
			)}

			{/* SHAPE FROM BOTTOM TEAM IN MATCH */}
			{(phase.direction != 0) && (
				<Shape
					sceneFunc={(context, shape) => {
						context.beginPath();
						context.moveTo(0, 0);
						context.lineTo(m * stage_padding, 0);
						context.lineTo(m * stage_padding, -m * (box_y_pos + final_point_y));
						if(used_color_team_2 == winner_color || used_color_team_1 != winner_color) context.lineTo(m * min_matches_separation, -m * (box_y_pos + final_point_y));
						context.fillStrokeShape(shape);
					}}
					stroke={(force_color) ? force_color : used_color_team_2}
					y={m * ((area_height + box_height) / 2 + box_y_pos)}
					{...connector_stroke_default_props}
				/>
			)}

			{(phase.direction != 0) && (
				<Group>
					{(phase.phase_id > 0) && (
						<Group>
							{/* CIRCLE IN "NEXT MATCH" CONNECTOR FROM TOP TEAM IN MATCH */}
							<Arc fill={(force_color) ? force_color : used_color_team_1} y={m * ((area_height + box_height) / 2 - box_y_pos)} {...arc_default_props} />

							{/* CIRCLE IN "NEXT MATCH" CONNECTOR FROM BOTTOM TEAM IN MATCH */}
							<Arc fill={(force_color) ? force_color : used_color_team_2} y={m * ((area_height + box_height) / 2 + box_y_pos)} {...arc_default_props} />
						</Group>
					)}

					{/* CIRCLE IN "PREVIOUS MATCH" CONNECTOR FROM TOP TEAM IN MATCH */}
					<Arc
						angle={180}
						rotation={90 * phase.direction}
						innerRadius={0}
						outerRadius={n * joining_lines_pointer_radius}
						fill={(force_color) ? force_color : ((used_color_team_1 == winner_color || used_color_team_2 == winner_color) ? winner_color : pending_color)}
						x={m * ((phase.direction < 0) ? -min_matches_separation : box_width + min_matches_separation)}
						y={m * ((area_height + box_height) / 2 - ((phase.phase_id == props.total_rounds - 1) ? final_point_y : 0))}
					/>

					{/* CIRCLE IN "CONNECTION" BETWEEN TOP AND BOTTOM TEAMS IN MATCH */}
					<Circle
						radius={n * joining_lines_pointer_radius}
						fill={(force_color) ? force_color : ((!props.is_future_phase && (used_color_team_1 == winner_color || used_color_team_2 == winner_color)) ? winner_color : pending_color)}
						x={m * ((phase.direction > 0) ? (box_width + stage_padding) : -stage_padding)}
						y={m * ((area_height + box_height) / 2 - final_point_y)}
					/>
				</Group>
			)}
		</Group>
	);
};

const BracketsCanvas = forwardRef((props, ref) => {
	const min_text_scale = 0.2;
	const max_text_scale = 1;

	const [canvas_size_w, setCanvasSizeW] = useState(650);
	const [canvas_size_h, setCanvasSizeH] = useState(400);
	const [maximum_text_width, setMaximumTextWidth] = useState(0);
	const [text_scale, setTextScale] = useState(min_text_scale);
	const [selected_match, setSelectedMatch] = useState(false);
	const [box_height, setBoxHeight] = useState(10);
	const [text_positions, setTextPositions] = useState({ _1_lines:0, _2_lines:0, _3_lines:0, _4_lines:0 });
	const [window_w, setWindowW] = useState(window.innerWidth);
	const [phases, setPhases] = useState([]);
	const [base64_image, setBase64Image] = useState((props.base64_image != undefined) ? props.base64_image : false);

	const bracket_id = generateUUID();

	const resize_screen = () => {
		if(base64_image === false) {
			if(throttle_resize != undefined) clearTimeout(throttle_resize);

			throttle_resize = setTimeout(() => {
				setWindowW(window.innerWidth);
			}, 200);
		}
	};

	let already_managed_texts = useRef(0);
	let loaded_images = useRef(0);
	let loaded_backgrounds = useRef(0);
	let loaded_whole_bgs = useRef(0);
	let width_multiplier = useRef(1);
	let available_container_width = useRef(100);
	let winner_position = useRef(false);
	let is_zoomed_out = useRef(false);
	let whole_bg_size = useRef({ width:2000, height:1300 });
	let refs = useRef([]);

	const is_builder = (props.is_builder != undefined) ? props.is_builder : false;
	const is_single = (props.is_single != undefined) ? props.is_single : false;
	const is_widget = (is_single && window.in_widget != undefined) ? window.in_widget : false;
	const is_iconic = (props.version != undefined && props.version == 'iconic') ? true : false;
	const is_zoomable = (!is_iconic) ? true : false;
	let is_zoomed = (props.is_zoomed != undefined) ? props.is_zoomed : false;
	if(is_single && (!is_widget || true)) is_zoomed = true;
	const in_mosaic = (props.in_mosaic != undefined) ? props.in_mosaic : false;

	const is_fkn_safari = (is_zoomable && !is_zoomed && !isDesktop() && isIOS()) ? true : false;

	// EXTERNAL DATA - ini
	let bracket = (props.bracket != undefined) ? props.bracket : false;
	if(!bracket) return null;

	useImperativeHandle(ref, () => ({
		bracket_to_image() {
			if(is_builder && refs.current['main_stage'] != undefined) {
				refs.current['connectors'].cache();
				refs.current['candidates'].cache();

				let dataURL = refs.current['main_stage'].toDataURL({
					pixelRatio:1,
				});

				return dataURL;
			}
		}
	}));

	const bracketToImage = () => {
		if(!is_builder && base64_image === false && refs.current['main_stage'] != undefined) {
			refs.current['connectors'].cache();
			refs.current['candidates'].cache();

			let dataURL = refs.current['main_stage'].toDataURL({
				pixelRatio:2,
			});

			setBase64Image(dataURL);
		}
	};

	let _has_images = detectIfBracketHasImages(props.teams);
	let has_images = (_has_images.images > 0 || _has_images.bg_images > 0) ? true : false;
	const [bg_loaded, setBgLoaded] = useState((bracket.background_img != undefined && bracket.background_img != "") ? false : true);
	const [imgs_loaded, setImgsLoaded] = useState((has_images) ? false : true);

	let display_votes = (!is_iconic && (true || (bracket.display_votes != undefined && bracket.display_votes == '1'))) ? true : false;
	let display_scores = (!is_iconic && bracket.display_scores != undefined && bracket.display_scores == '1') ? true : false;

	let total_rounds = parseInt(bracket.num_rounds);
	let current_round = parseInt(bracket.current_round);
	let actual_round = (props.current_round != undefined) ? props.current_round : current_round;
	let actual_match = (props.current_match != undefined) ? props.current_match : 1;
	let matches_results = (props.matches_results != undefined) ? props.matches_results : false;

	const [teams, setTeams] = useState(props.teams);

	// EXTERNAL DATA - end
	const [whole_bg_image, setWholeImage] = useState(false);

	let images_loading = {};
	let backgrounds_loading = {};
	let whole_bg_loading = {};
	const handleLoad = (image, index, type) => {
		let teams_tmp = [...teams];

		if(type == 'image') {
			var image = images_loading[index];
		} else if(type == 'background') {
			var image = backgrounds_loading[index];
		} else if(type == 'whole_background') {
			var image = whole_bg_loading[index];
		}
		const new_image = {
			fillPatternImage:image,
			image_w:image.width,
			image_h:image.height,
		};

		let this_team = teams_tmp.find((obj) => { return obj.id == index });

		if(type == 'image') {
			this_team.object_image = new_image;
			loaded_images.current++;
			//delete this_team.object_background;
		} else if(type == 'background') {
			this_team.object_background = new_image;
			loaded_backgrounds.current++;
		} else if(type == 'whole_background') {
			setWholeImage({ object_image:new_image });
			loaded_whole_bgs.current++;
			setBgLoaded(true);
		}

		if(loaded_images.current == _size(images_loading) && loaded_backgrounds.current == _size(backgrounds_loading)) {
			// && loaded_whole_bgs.current == whole_bg_loading.length
			setImgsLoaded(true);
			setTeams(teams_tmp);
		}
	};

	const getTokensInString = (text) => {
		let result = [];

		if(typeof text === 'string') {
			let tokens = text.split(/[\s\n]+/);

			for(var i = 0; i < tokens.length; i++) {
				if(tokens[i].length > 0) result.push(tokens[i]);
			}
		}

		return result;
	};

	const hasBrokenWords = (sourceTokens, renderLines) => {
		let combined = "";
		for(var i = 0; i < renderLines.length; i++) {
			combined += ((i === 0) ? "" : " ") + renderLines[i].text;
		}

		let a = sourceTokens;
		let b = getTokensInString(combined);

		if(a.length !== b.length) return true;

		for(var i = 0; i < a.length; i++) {
			if(a[i] !== b[i]) return true;
		}

		return false;
	};

	const getNumTextLines = (text_obj) => {
		return (text_obj != undefined && !use_abbreviations) ? text_obj.textArr.length : min_num_text_lines;
	};

	const get_max_lines = () => {
		let num_lines = min_num_text_lines;

		if(use_abbreviations) return num_lines;

		teams.map((team, t) => {
			let actual_text = refs.current[`text_helper_${team.id}`];
			let this_num_lines = (actual_text != undefined) ? actual_text.textArr.length : 0;

			if(this_num_lines > num_lines) num_lines = this_num_lines;
		});

		return num_lines;
	};

	const getTextScale = () => {
		if(is_iconic || already_managed_texts.current > 0) return false;

		let max_text_width = 0;
		let max_text_height = 0;

		teams.map((team, t) => {
			teams[t].round = parseInt(teams[t].round);

			let actual_text = (use_abbreviations) ? refs.current[`text_helper_abbr_${team.id}`] : refs.current[`text_helper_${team.id}`];
			actual_text.cache();

			let sourceTokens = getTokensInString(actual_text.attrs.text);
			let brokenWords = hasBrokenWords(sourceTokens, actual_text.textArr);
			let actual_width = (actual_text != undefined) ? actual_text.textWidth : 0;

			if(brokenWords) {
				let j = 0;
				for(var i in sourceTokens) {
					if(actual_text.textArr[j] != undefined) {
						let new_width = actual_text.textArr[j].width;
						if(actual_text.textArr[j].text == sourceTokens[i]) {
							j++;
							if(actual_width < new_width) actual_width = new_width;
							continue;
						}

						if(actual_text.textArr[j + 1] != undefined) new_width += actual_text.textArr[j + 1].width;
						if(actual_width < new_width) actual_width = new_width;
						j += 2;
					}
				}
			}

			teams[t].num_lines = getNumTextLines(actual_text);

			if(max_text_width < actual_width) max_text_width = actual_width;
			if(actual_text != undefined && max_text_height < actual_text.textHeight) max_text_height = actual_text.textHeight;
		});
		setTeams(teams);

		already_managed_texts.current = already_managed_texts.current + 1;
		setMaximumTextWidth(max_text_width);
	};

	const getBoxHeight = () => {
		let box_h = 0;

		if(!is_iconic) {
			if(display_team_images_only) {
				box_h = box_width / 2;
			} else if(display_team_full_name) {
				let max_lines = (display_team_images) ? min_num_text_lines : get_max_lines();
				box_h = (max_lines * font_size_basis * text_scale + 2 * box_padding_v);
			}
		}

		return Math.max(box_width / 3, box_h);
	};

	const getBoxWidth = () => {
		let box_w = 0;

		if(!is_iconic) {
			if(display_team_images_only && total_rounds != 4) {
				box_w = box_height * 2;
			}
		}

		return Math.max(box_height * 3, box_w);
	};

	const getBoxPositionY = (phase, p) => {
		let match_sep_h = box_height + stage_padding;

		if(phase.direction != 0) {
			if(total_rounds == 2) {
				match_sep_h = total_height_global - box_height;
			} else if(phase.phase_id != 1) {
				// if not in first phase or final, we take the separation of the previous phase:
				match_sep_h = (canvas_size_h / visible_phases[p - 1 * phase.direction].matches.length);
			}
		}

		return match_sep_h / 2;
	};

	const getMatchesInVisiblePhase = (_phases, loop_end, i, is_right_side) => {
		let matches_areas = [];

		if(is_right_side == undefined) is_right_side = false;
		let is_final_round = (i > 99) ? true : false;
		let is_it_winner = (!is_final_round) ? (i + 1) : phases[phases.length - 1].id;

		for(var j = 0; j < loop_end; j++) {
			let team_1;
			let team_2;
			let parent_1;
			let parent_2;
			let verify_to_winner = i;

			if(i == 0) {
				let index_added = (is_right_side) ? teams.length / 2 : 0;

				team_1 = {...props.teams[index_added + j]};
				team_2 = {...props.teams[index_added + j + 1]};
			} else {
				if(!is_final_round) {
					let k = (is_right_side) ? (i + phases.length - 1) : i;
					parent_1 = _phases[k - 1].matches[j];
					parent_2 = _phases[k - 1].matches[j + 1];
				} else {
					parent_1 = _phases[_phases.length / 2 - 1].matches[0];
					parent_2 = _phases[_phases.length - 1].matches[0];
					verify_to_winner = phases.length - 1;
				}

				team_1 = (parent_1.winner !== false) ? parent_1.teams[parent_1.winner] : false;
				team_2 = (parent_2.winner !== false) ? parent_2.teams[parent_2.winner] : false;
			}

			let winner = (team_1.round > is_it_winner) ? 0 : ((team_2.round > is_it_winner) ? 1 : false);

			j++;

			matches_areas.push({ teams:[team_1, team_2], winner:((phases[verify_to_winner].id < actual_round) ? winner : false) });
		}

		return matches_areas;
	};

	const generateVisiblePhases = (phases) => {
		let bracket_phases = [];
		if(phases.length == 0 || teams.length < 1) return bracket_phases;

		for(var i = 0; i < phases.length - 1; i++) {
			let matches_areas = getMatchesInVisiblePhase(bracket_phases, phases[i].matches * 2, i, false);
			bracket_phases.push({ id:(bracket_phases.length + 1), phase_id:phases[i].id, matches:matches_areas, order:phases[i].order, direction:1 });
		}

		for(var i = 0; i < phases.length - 1; i++) {
			let matches_areas = getMatchesInVisiblePhase(bracket_phases, phases[i].matches * 2, i, true);
			bracket_phases.push({ id:(bracket_phases.length + 1), phase_id:phases[i].id, matches:matches_areas, order:phases.length + Math.abs(phases[i].order - phases.length), direction:-1 });
		}

		let matches_areas = getMatchesInVisiblePhase(bracket_phases, 1, 100);
		bracket_phases.push({ id:(bracket_phases.length + 1), phase_id:phases[phases.length - 1].id, matches:matches_areas, order:phases[phases.length - 1].order, direction:0 });

		return sortPhases(bracket_phases);
	};

	const adaptBracketToContainer = (force_execution) => {
		if(force_execution == undefined) force_execution = false;

		if(force_execution) whole_bg_size.current = { width:2000, height:800 };

		if((is_builder && props.getBgSize != undefined) || is_widget || force_execution) {
			let expected_width = 2000;
			let expected_height = Math.ceil((whole_bracket_height - header_height) * expected_width / total_width_global);

			if(whole_bg_size.current.width != expected_width || whole_bg_size.current.height != expected_height || force_execution) {
				whole_bg_size.current = { width:expected_width, height:expected_height };

				if(is_builder && props.getBgSize != undefined) {
					props.getBgSize(whole_bg_size.current);
				} else if(is_widget) {
					let iframe_height = window_w * (2 * header_height + expected_height) / expected_width;
					adaptWidgetHeight(iframe_height);
				}
			}
		}
	};

	const visible_phases = generateVisiblePhases(phases);

	// COLORS - ini
	let main_color = (props.main_color != undefined) ? props.main_color : 'rgba(60, 70, 200, 1)';
	let is_main_color_bright = isColorBright(RGB_2_HEX(main_color));
	let bracket_bg_color = (bracket.background_color != undefined) ? bracket.background_color : ((is_main_color_bright) ? '#4D4D4D' : white_color);
	let header_bg_color = (bracket.header_color != undefined) ? bracket.header_color : main_color;
	let is_header_bg_color_bright = isColorBright(RGB_2_HEX(header_bg_color));

	let is_bracket_bg_color_bright = isColorBright(RGB_2_HEX(bracket_bg_color));

	let is_bracket_light = (bracket.layout != undefined) ? ((bracket.layout == 'light') ? true : false) : is_bracket_bg_color_bright;
	let plain_box_color = (is_iconic) ? main_color : ((!is_bracket_light) ? black_color : white_color);
	let is_main_bg_color_bright = isColorBright(RGB_2_HEX(plain_box_color));

	let connectors_color = (is_bracket_light) ? black_color : white_color;
	let winner_color = (is_iconic) ? ((is_main_bg_color_bright) ? black_color : white_color) : connectors_color;
	//let pending_color = (is_iconic) ? ((is_main_bg_color_bright) ? black_color : white_color) : ((is_main_bg_color_bright) ? 'rgba(140, 140, 140, 1)' : 'rgba(140, 140, 140, 1)');
	let pending_color = winner_color;
	let loser_color = (is_iconic) ? ((is_main_bg_color_bright) ? 'rgba(0, 0, 0, 0.3)' : 'rgba(255, 255, 255, 0.3)') : 'rgba(150, 150, 150, 1)';
	// COLORS - end

	let main_font = (props.main_font != undefined && false) ? props.main_font : 'SanFrancisco';	// we disable the main_font specification because it may have a loading lack, which ends on having extra text width

	// LAYOUT PROPS - ini
	let display_crosses_on_losers = (bracket.losers_display != undefined && bracket.losers_display == '1') ? true : false;
	let display_rounds = (!is_iconic) ? true : false;

	let teams_display = (bracket.teams_display != undefined) ? parseInt(bracket.teams_display) : 0;
	let display_team_images = (!is_iconic && teams_display > 0) ? true : false;
	let display_team_full_name = (teams_display < 2) ? true : false;
	let display_team_images_only = (display_team_images && teams_display == 3) ? true : false;
	let display_team_texts = (!is_iconic && !display_team_images_only) ? true : false;
	let use_abbreviations = (teams_display == 2) ? true : false;
	// LAYOUT PROPS - end

	// LAYOUT SPECS - ini
	const num_phases = 2 * total_rounds - 1;
	const min_num_text_lines = 2;
	let font_size_basis = (total_rounds > 2) ? 10 : 10; // pt
	let stage_padding = (!is_iconic) ? 12 : 10;
	const min_matches_separation = 2 * stage_padding;

	let box_border_width = 1;
	let box_padding_v = font_size_basis / 3;
	let box_padding_h = font_size_basis / 2;

	let total_width_global = canvas_size_w + min_matches_separation;
	let phase_width = total_width_global / num_phases;
	let box_width = phase_width - min_matches_separation;
	// LAYOUT SPECS - end

	let total_height_divider;
	let header_height_multiplier = (total_rounds > 2) ? 1.5 : 1.0;
	let header_font_size_basis = 7 + 2 * (total_rounds - 2);
	switch(total_rounds) {
		case 4:
		case 5:
			total_height_divider = total_rounds;
			break;
		default:
			total_height_divider = (total_rounds + 1) / 2;
			break;
	}
	let header_height = (!display_rounds) ? 0 : header_height_multiplier * (header_font_size_basis + stage_padding);

	let top_separation_in_first_stage = canvas_size_h / total_height_divider - (2 * box_height + stage_padding);
	let total_height_global = canvas_size_h - top_separation_in_first_stage;
	//if(total_rounds == 2) total_height_global -= box_border_width;

	let whole_bracket_height = Math.max(0, parseInt(total_height_global + header_height + min_matches_separation));
	if(isNaN(whole_bracket_height)) whole_bracket_height = 100;

	width_multiplier.current = (is_zoomable) ? (total_width_global / available_container_width.current) : 1;

	let container_w = $((in_mosaic) ? '.brackets_display' : '.gui_bracket_builder').width();
	let total_height_correction = (is_single) ? 0 : 60;
	let default_mult = (window.innerWidth > container_w) ? 2.5 : 1;
	let mult = (is_zoomable) ? ((is_zoomed) ? ((window.innerHeight - total_height_correction) / (canvas_size_h + 2 * header_height)) : default_mult) : 1;	// scale multiplier

	let c_styles = {};
	let percent_w = 1;
	if(is_zoomable && !is_zoomed) {
		percent_w = container_w / (mult * total_width_global);
		if(percent_w < 1) {
			if(!actual_browser.firefox) {
				c_styles.zoom = percent_w;
			} else {
				c_styles.transform = 'scale(' + percent_w + ')';
				c_styles.transformOrigin = '50% 0 0';
			}
		}
		const _is_zoomed_out = (percent_w < 0.85) ? true : false;
		is_zoomed_out.current = _is_zoomed_out;
		if(props.set_is_zoomable != undefined) props.set_is_zoomable(_is_zoomed_out);
	}
	let m = (is_fkn_safari) ? 1.75 : mult;

	let n = 1;	// scale multiplier for stroke widths
	if(is_zoomable && !is_zoomed) {
		switch(total_rounds) {
			case 2:
				n = (is_zoomed_out.current) ? Math.max(1, m - 1) : 1;
				break;
			default:
				n = (is_zoomed_out.current) ? m : 1;
				break;
		}
	}

	let winner_team = teams.find((obj) => { return obj.round > total_rounds });
	let has_final_winner = (winner_team) ? true : false;
	let display_final_winner = (!is_iconic && has_final_winner && total_rounds < actual_round) ? true : false;

	const getImagesOnTeam = (_team) => {
		if(_team === false || !(_team.object_image !== undefined || _team.object_background !== undefined)) return false;
		let image = false;
		let image_scale = 1;

		if(_team.object_image !== undefined) {
			image = _team.object_image;
			image_scale = (box_height / image.image_h);
		}

		if(display_team_images_only) {
			if(_team.object_background !== undefined) image = _team.object_background;
			image_scale = box_width / image.image_w;
		}

		return { img:image, scale:image_scale };
	};

	const getBackgroundImage = (_img) => {
		if(_img === false || _img.object_image == undefined) return false;

		let image = false;
		let image_x = 0;
		let image_y = 0;

		image = _img.object_image;

		let image_scale_x = total_width_global / image.image_w;
		let image_scale_y = (whole_bracket_height - header_height) / image.image_h;
		let image_scale = Math.max(image_scale_x, image_scale_y);

		image_x = (total_width_global - image_scale * image.image_w) / 2;
		image_y = (whole_bracket_height - image_scale * image.image_h) / 2;

		return { img:image, scale:image_scale, position:{ x:image_x, y:image_y} };
	};

	useEffect(() => {
		if(!is_iconic) {
			setSelectedMatch(false);
		} else {
			if(num_phases == 0 || visible_phases.length == 0) return;

			let is_right_side = (visible_phases[actual_round - 1].matches.length < actual_match) ? true : false;
			let ph = actual_round + ((is_right_side) ? (Math.log2(teams.length) - visible_phases[actual_round - 1].phase_id) * 2 : 0);
			let mt = actual_match - ((is_right_side) ? visible_phases[actual_round - 1].matches.length : 0);

			let _selected_match = (ph - 1) + "_" + (mt - 1);
			setSelectedMatch(_selected_match);
		}

		return () => { };
	}, [actual_round, actual_match, phases, is_iconic]);

	useEffect(() => {
		if(display_team_texts) {
			let text_positions = {};
			for(var i = 1; i < 5; i++) {
				let text_height = ((use_abbreviations) ? 1 : i) * text_scale * font_size_basis;
				text_positions[`_${i}_lines`] = 1 + (box_height - text_height) / 2;
			}

			setTextPositions(text_positions);
		}
	}, [text_scale, box_height, use_abbreviations, display_team_texts]);

	useEffect(() => {
		setMaximumTextWidth(0);
		already_managed_texts.current = 0;
		getTextScale();

		setBoxHeight(getBoxHeight());
	}, [box_width, display_team_full_name, display_team_images_only, display_team_images]);

	useEffect(() => {
		let total_h = 2 * total_rounds * (box_height + min_matches_separation);

		setCanvasSizeH(total_h);
	}, [box_height]);

	useEffect(() => {
		let available_width_in_box = box_width - 2 * box_padding_h - ((display_team_images && !display_team_images_only) ? box_height : 0);
		let text_scale_x = (maximum_text_width > available_width_in_box) ? (available_width_in_box / maximum_text_width) : 1;
		let text_scale_y = 1;

		let text_scale = Math.max(min_text_scale, Math.min(text_scale_x, text_scale_y, max_text_scale));

		setTextScale(0.75 * text_scale);
	}, [maximum_text_width, use_abbreviations, canvas_size_w]);

	useEffect(() => {
		props.teams.map((item, index) => {
			if(item.background != undefined && display_team_images_only === true) {
				let found_bkg = (_size(teams) > 0) ? teams.find((obj) => { return obj.id == item.id  && obj.object_background != undefined}) : false;

				if(!found_bkg) {
					backgrounds_loading[item.id] = new window.Image();
					backgrounds_loading[item.id].crossOrigin = 'Anonymous';
					backgrounds_loading[item.id].src = item.full_background;
					backgrounds_loading[item.id].onload = () => {
						handleLoad(backgrounds_loading[item.id], item.id, 'background');
					}
				}
			}

			if(item.image != undefined && display_team_images_only === false) {
				let found_img = (_size(teams) > 0) ? teams.find((obj) => { return obj.id == item.id  && obj.object_image != undefined}) : false;

				if(!found_img) {
					images_loading[item.id] = new window.Image();
					images_loading[item.id].crossOrigin = 'Anonymous';
					images_loading[item.id].src = ((item.full_thumb_image != undefined && item.full_thumb_image != '') ? item.full_thumb_image : item.full_image);
					images_loading[item.id].onload = () => {
						handleLoad(images_loading[item.id], item.id, 'image');
					}
				}
			}

			if(item.background == undefined && item.image == undefined && teams[item.id] != undefined) {
				delete teams[item.id].object_image;
				delete teams[item.id].object_background;
			}

			setImgsLoaded(true);
		});
	}, [props.teams]);

	useEffect(() => {
		if(bracket.full_background_img != undefined && bracket.full_background_img != "") {
			whole_bg_loading[0] = new window.Image();
			whole_bg_loading[0].crossOrigin = 'Anonymous';
			whole_bg_loading[0].src = bracket.full_background_img;
			whole_bg_loading[0].onload = () => {
				handleLoad(whole_bg_loading[0], 0, 'whole_background');
			}
		}
	}, [bracket.full_background_img]);

	useEffect(() => {
		let phases = [];
		loaded_images.current = 0;

		for(var p = total_rounds; p > 0; p--) {
			phases.push({
				id:p,
				label:getRoundLabel(bracket, p, false, props.intl),
				matches:Math.max(1, teams.length / Math.pow(2, p + 1)),
				order:p,
			});
		}

		phases = sortPhases(phases);
		setPhases(phases);

		let total_w;
		let _available_container_width = document.getElementById('brackets_' + bracket_id).getBoundingClientRect().width;

		if(is_zoomable) {
			// ZOOMED HEIGHT is leading:
			switch(parseInt(total_rounds)) {
				case 5:
				case 4:
					_available_container_width -= 1 * stage_padding;
					break;
				case 3:
					_available_container_width -= 2 * stage_padding;
					break;
				case 2:
					_available_container_width -= 3.5 * stage_padding;
					break;
			}
			available_container_width.current = _available_container_width;

			const box_w = getBoxWidth();
			const num_rounds = Math.pow(2, total_rounds) + 1;
			total_w = num_rounds * (box_w + min_matches_separation);
		} else {
			// AVAILABLE WIDTH is leading:
			total_w = width_multiplier.current * _available_container_width - min_matches_separation;
		}

		setCanvasSizeW(total_w);

		// After ellapsed 4 seconds, we force the "loaded" state to prevent infinite loading times
		const t = setTimeout(() => {
			if(!bg_loaded) setBgLoaded(true);
			if(!imgs_loaded) setImgsLoaded(true);
			if(is_fkn_safari) bracketToImage();
		}, 3000);

		window.addEventListener("resize", resize_screen);

		return () => {
			window.removeEventListener("resize", resize_screen);
			refs.current['main_stage'].destroy();
		};
	}, []);

	const generic_group_props = {
		offsetX:m * box_width / 2,
		offsetY:m * box_height / 2,
		x:m * (box_width / 2 + stage_padding),
	};

	const main_generic_props = {
		m:m,
		n:n,
		box_width:box_width,
		box_height:box_height,
		box_border_width:box_border_width,
		min_matches_separation:min_matches_separation,
		stage_padding:stage_padding,
		is_iconic:is_iconic,
	};

	const default_text_props = {
		fontFamily:main_font,
		fontSize:m * font_size_basis * text_scale,
		fontStyle:'bold',
		lineHeight:1,
	};

	const text_box_width = box_width - 2 * box_padding_h - ((display_team_images) ? box_height : 0);
	const default_generic_helper_text_props = {
		...default_text_props,
		fontSize:default_text_props.fontSize / m,
		width:text_box_width,
	};

	const connector_generic_props = {
		connectors_color:connectors_color,
		generic_group_props:generic_group_props,
		pending_color:pending_color,
		total_rounds:phases.length,
		is_iconic:is_iconic,
		winner_color:winner_color,
	};

	const team_box_default_props = {
		display_scores:display_scores,
		display_team_images:display_team_images,
		display_team_images_only:display_team_images_only,
		display_team_texts:display_team_texts,
		display_team_full_name:display_team_full_name,
		display_final_winner:display_final_winner,
		display_crosses_on_losers:display_crosses_on_losers,
		is_single:is_single,
		main_color:main_color,
		flip_images:(bracket.autoflip_candidates != undefined && bracket.autoflip_candidates == '1') ? true : false,
		winner_color:winner_color,
		bracket_layout:bracket.layout,
		generic_group_props:generic_group_props,
		generic_score_text_props:{
			offsetX:m * (box_width / 2 - box_padding_h),
			width:m * (box_width - 2 * box_padding_h),
			...default_text_props,
			fontSize:((total_rounds > 2) ? 1 : 0.8) * default_text_props.fontSize,
		},
		loser_props:{
			displace_icon:(display_team_images && !display_team_images_only) ? true : false,
		},
		generic_text_props:{
			align:'center',
			offsetX:m * (box_width / 2 - box_padding_h),
		},
		default_generic_text_props:{
			width:m * text_box_width,
			...default_text_props,
		},
	};

	let canvas_contents_x = 0;
	let canvas_contents_y = -top_separation_in_first_stage / 2 + header_height + stage_padding;

	let bg_image = getBackgroundImage(whole_bg_image);

	let this_bracket_styles = {};
	if(is_zoomed || is_single) {
		this_bracket_styles.height = '100%';	//100dvh
		if(window_w > (m * (canvas_size_w + min_matches_separation))) {
			this_bracket_styles.justifyContent = 'center';
		}
	}
	if(_size(c_styles) > 0 && actual_browser.firefox) {
		this_bracket_styles.height = percent_w * m * whole_bracket_height;
		this_bracket_styles.overflow = 'hidden';
	}

	let all_loaded = (bg_loaded && imgs_loaded) ? true : false;

	if(is_builder && props.getBgSize != undefined) {
		let expected_width = 2000;
		let expected_height = Math.ceil((whole_bracket_height - header_height) * expected_width / total_width_global);

		if(whole_bg_size.current.width != expected_width || whole_bg_size.current.height != expected_height) {
			whole_bg_size.current = { width:expected_width, height:expected_height };
			props.getBgSize(whole_bg_size.current);
		}
	}

	let display_view_votes_link = (display_votes && all_loaded && is_zoomable && percent_w > 0.7) ? true : false;
	let is_voting_bracket = (bracket.type == 1) ? true : false;

	adaptBracketToContainer(is_widget);

	let wrapper_props = {
		all_loaded:all_loaded,
		bracket:bracket,
		c_styles:c_styles,
		display_rounds:display_rounds,
		display_view_votes_link:display_view_votes_link,
		display_votes:display_votes,
		header_font_size_basis:header_font_size_basis,
		header_height:header_height,
		intl:props.intl,
		is_builder:is_builder,
		is_header_bg_color_bright:is_header_bg_color_bright,
		is_single:is_single,
		is_widget:(is_widget && false),
		is_zoomable:is_zoomable,
		is_zoomed:is_zoomed,
		is_zoomed_out:is_zoomed_out.current,
		is_voting_bracket:is_voting_bracket,
		link_to_single:props.link_to_single,
		m:m,
		main_color:main_color,
		matches_results:matches_results,
		phases:phases,
		promotion:props.promotion,
		teams:teams,
		text_scale:text_scale,
		this_bracket_styles:this_bracket_styles,
		total_width_global:total_width_global,
		visible_phases:visible_phases,
	}

	if(base64_image !== false) {
		return (
			<Wrapper bracket_id={bracket_id} {...wrapper_props}>
				<img src={base64_image} width="100%" />
			</Wrapper>
		)
	}

	return (
		<Wrapper bracket_id={bracket_id} {...wrapper_props}>
			{(!isNaN(canvas_size_h)) && (
				<Stage ref={(node) => { refs.current['main_stage'] = node; }} className="gui_brackets_container canvas_cont" width={m * total_width_global} height={m * whole_bracket_height} opacity={(all_loaded) ? 1 : 0}>
					{(!is_iconic) && (
						<Layer>
							<Rect width={m * total_width_global} height={m * whole_bracket_height} fill={bracket_bg_color} />
							{(whole_bg_image !== false) && (
								<Rect
									width={m * total_width_global}
									height={m * whole_bracket_height}
									y={m * header_height}
									fillPatternImage={bg_image.img.fillPatternImage}
									fillPatternRepeat='no-repeat'
									fillPatternScaleX={m * bg_image.scale}
									fillPatternScaleY={m * bg_image.scale}
									fillPatternX={m * bg_image.position.x}
									fillPositionX={0}
								/>
							)}

							<Rect width={m * total_width_global} height={m * header_height} fill={header_bg_color} />

							{visible_phases.map((phase, p) => {
								if(phase.phase_id != actual_round - 1) return null;

								let x_pos = p * phase_width;
								let selected_round_bg_color = (is_header_bg_color_bright) ? 'rgba(0, 0, 0, 0.15)' : 'rgba(255, 255, 255, 0.3)';

								return (
									<Rect key={`phase_bg_${p}`} x={m * x_pos} width={m * phase_width} height={m * header_height} fill={selected_round_bg_color} />
								)
							})}

							<Group y={header_height} x={m * (canvas_size_w / 2 - box_width)} opacity={0}>
								{teams.map((team, t) => {
									let name = (team.name != null) ? team.name : "";
									let short_name = (team.short_name != null) ? team.short_name : "";

									return (
										<Group key={`helpers_${t}`}>
											<Text ref={(node) => { refs.current[`text_helper_${team.id}`] = node; }} key={`text_helper_${team.id}`} x={0} y={t * (box_height + 10)} text={name} {...default_generic_helper_text_props} />

											<Text ref={(node) => { refs.current[`text_helper_abbr_${team.id}`] = node; }} key={`text_helper_abbr_${team.id}`} x={0} y={t * (box_height + 10)} text={short_name} {...default_generic_helper_text_props} />
										</Group>
									)
								})}
							</Group>
						</Layer>
					)}

					<Layer ref={(node) => { refs.current['connectors'] = node; }} x={m * canvas_contents_x} y={m * canvas_contents_y}>
						{visible_phases.map((phase, p) => {
							let box_y_pos = getBoxPositionY(phase, p);
							let is_future_phase = (actual_round < phase.phase_id + 1) ? true : false;

							return (
								<Group key={`phase_${p}`} x={m * p * phase_width}>
									{phase.matches.map((area, a) => {
										let used_color_team_1 = (area.winner !== false) ? ((area.winner == '0') ? winner_color : loser_color) : pending_color;
										let used_color_team_2 = (area.winner !== false) ? ((area.winner == '1') ? winner_color : loser_color) : pending_color;

										let match_id = p + "_" + a;

										let final_point_y = 0;
										if(phase.phase_id == phases.length - 1) final_point_y = phase.direction * ((box_height + stage_padding) / 2);

										let area_height = canvas_size_h / phase.matches.length;
										let y_pos = a * area_height + area_height / 2;

										const connector_props = {
											area_height:area_height,
											box_y_pos:box_y_pos,
											final_point_y:final_point_y,
											is_future_phase:is_future_phase,
											phase:phase,
											used_color_team_1:used_color_team_1,
											used_color_team_2:used_color_team_2,
										};

										return (
											<Group key={`connectors_${match_id}`} width={m * phase_width} height={m * area_height} y={m * y_pos} x={m * phase_width / 2} offsetX={m * phase_width / 2} offsetY={m * area_height / 2}>
												<TeamConnector {...connector_generic_props} {...connector_props} {...main_generic_props} />
											</Group>
										)
									})}
								</Group>
							)
						})}
					</Layer>

					<Layer ref={(node) => { refs.current['candidates'] = node; }} x={m * canvas_contents_x} y={m * canvas_contents_y}>
						{visible_phases.map((phase, p) => {
							let box_y_pos = getBoxPositionY(phase, p);
							let is_future_phase = (actual_round < phase.phase_id + 1) ? true : false;
							let is_actual_round = (actual_round == phase.phase_id) ? true : false;

							return (
								<Group key={`phase_${p}`} x={m * p * phase_width}>
									{phase.matches.map((area, a) => {
										let used_color_team_1 = (area.winner !== false) ? ((area.winner == '0') ? winner_color : loser_color) : pending_color;
										let used_color_team_2 = (area.winner !== false) ? ((area.winner == '1') ? winner_color : loser_color) : pending_color;
										let box_bg_color_1 = (is_iconic) ? used_color_team_1 : plain_box_color;
										let box_bg_color_2 = (is_iconic) ? used_color_team_2 : plain_box_color;
										let box_stroke_color_1 = (is_iconic) ? used_color_team_1 : pending_color;
										let box_stroke_color_2 = (is_iconic) ? used_color_team_2 : pending_color;

										let match_id = p + "_" + a;
										if(selected_match !== false && is_future_phase) {
											if(selected_match == match_id) {
												let affection_direction = 0.6 * ((is_main_bg_color_bright) ? 1 : -1);
												box_bg_color_1 = (is_iconic) ? affect_color_filter(affection_direction, main_color) : main_color;
												box_bg_color_2 = (is_iconic) ? affect_color_filter(affection_direction, main_color) : main_color;
											} else {
												box_bg_color_1 = plain_box_color;
												box_bg_color_2 = plain_box_color;
												box_stroke_color_1 = pending_color;
												box_stroke_color_2 = pending_color;
											}
										}

										let area_height = canvas_size_h / phase.matches.length;
										let y_pos = a * area_height + area_height / 2;

										if(phase.direction == 0 && has_final_winner && winner_position.current === false) {
											winner_position.current = (area.teams[0].id == winner_team.id) ? 'top' : 'bottom';
										}

										let match_score = matches_results[`${phase.phase_id}_${area.teams[0].id}_${area.teams[1].id}`];
										let area_box_props = {
											direction:phase.direction,
											num_rounds:total_rounds,
											text_height:font_size_basis * text_scale,
											winner:area.winner,
											winner_position:winner_position.current,
										};

										let text_1_y_pos = 0;
										if(area.teams[0] !== false) {
											let num_lines_1 = getNumTextLines(refs.current[`text_helper_${area.teams[0].id}`]);
											text_1_y_pos = text_positions[`_${num_lines_1}_lines`];
										}

										let top_box_props = {
											group_y:area_height / 2 - box_y_pos,
											team:area.teams[0],
											text_y_pos:text_1_y_pos,
											used_color_team:used_color_team_1,
											image:getImagesOnTeam(area.teams[0]),
											match_score:(match_score != undefined) ? match_score.score[0] : null,
											box_bg:box_bg_color_1,
											box_position:'top',
											box_stroke_color:box_stroke_color_1,
										};

										let text_2_y_pos = 0;
										if(area.teams[1] !== false) {
											let num_lines_2 = getNumTextLines(refs.current[`text_helper_${area.teams[1].id}`]);
											text_2_y_pos = text_positions[`_${num_lines_2}_lines`];
										}

										let bottom_box_props = {
											group_y:area_height / 2 + box_y_pos,
											team:area.teams[1],
											text_y_pos:text_2_y_pos,
											used_color_team:used_color_team_2,
											image:getImagesOnTeam(area.teams[1]),
											match_score:(match_score != undefined) ? match_score.score[1] : null,
											box_bg:box_bg_color_2,
											box_position:'bottom',
											box_stroke_color:box_stroke_color_2,
										};

										return (
											<Group key={`match_${match_id}`} width={m * phase_width} height={m * area_height} y={m * y_pos} x={m * phase_width / 2} offsetX={m * phase_width / 2} offsetY={m * area_height / 2}>
												<TeamBox {...top_box_props} {...area_box_props} {...team_box_default_props} {...main_generic_props} />

												<TeamBox {...bottom_box_props} {...area_box_props} {...team_box_default_props} {...main_generic_props} />
											</Group>
										)
									})}
								</Group>
							)
						})}
					</Layer>
				</Stage>
			)}
		</Wrapper>
	);
});
export default injectIntl(BracketsCanvas, { withRef:true });